import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import AlertsToggleView from "components/shared/views/BaseToggleView/components/AlertsToggleView";
import ControlToggleView from "components/shared/views/BaseToggleView/components/ControlToggleView";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React, { useState } from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function TransactionAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TransactionAlertsPage
 */
export default function TransactionAlertsPage(props) {
  const navigate = useRoute();
  const cancel = evt => navigate(-1);

  const [ state, setState ] = useState(false);
  const toggle = value => setState(value);

  const disabledIcon = <DisabledPrompt><SVGAsset id="RightChevronIcon" className="chevron-icon clickable" /></DisabledPrompt>;

  return (
    <MainContentContainer className="transaction-alerts-page" header={
      <MainContentHeader text="Transaction Alerts" />
      }>
      <FormContainer>
        <AlertsToggleView 
          mainText="Enable Merchant Alerts" 
          subText="Alert me for selected merchant types."
          onChange={ toggle }
          icon={ disabledIcon }
          className="hide-chevron-icon" />

        <ControlToggleView
          mainText="In Store"
          subText="Department stores, pharmacies and other card purchases si..."
          checked={ state }
          icon={ disabledIcon }
          className={ !state ? "disabled" : "" } />

        <ControlToggleView
          mainText="Online / eCommmerce"
          subText="Online bill payments, online shopping, and other online purc..."
          checked={ state }
          icon={ disabledIcon }
          className={ !state ? "disabled" : "" } />

        <ControlToggleView
          mainText="Recurring / Autopay"
          subText="Automated bills, monthly subscriptions, and other purchases..."
          checked={ state }
          icon={ disabledIcon }
          className={ !state ? "disabled" : "" } />

        <ControlToggleView
          mainText="ATM"
          subText="Cash dispensers, cash kiosks, and ATM withdrawals. ATM pur..."
          checked={ state }
          icon={ disabledIcon }
          className={ !state ? "disabled" : "" } />

        <ControlToggleView
          mainText="Other"
          subText="Other purchases that cannot be defined by a different transa..."
          checked={ state }
          icon={ disabledIcon }
          className={ !state ? "disabled" : "" } />

        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Apply" />
          </DisabledPrompt>
          <UICancelButton text="Cancel" onClick={ cancel } />
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}